module.exports = __webpack_public_path__ + "img/p_8.043d0155.jpg";